import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MiddlewareComponent } from '../middleware/middleware.component';
import { LandingComponent } from './landing.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { VerifiedPnlComponent } from '../features/verified-pnl/verified-pnl.component';
import { AuthGuard } from '.././services/auth/auth.guard';


const routes: Routes = [
  {
    path: '',
    component: LandingComponent
    // canActivate: [NoAuthGuard]
  },
  {
    path: 'middleware',
    component: MiddlewareComponent
  },
  {
    path: 'thank-you',
    component: ThankYouComponent
  },
  {
    path:'verified-pnl', 
    component:VerifiedPnlComponent
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LandingRoutingModule { }
